import { Box } from '@mui/material';

import { getContrastYIQ } from 'src/pages/chat/components/shared/misc/chat-label';

import { Label } from 'src/components/label';

// ----------------------------------------------------------------------

type Props = {
  row: any;
};

// ----------------------------------------------------------------------

export function RowCellLabels({ row }: Props) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {'labels' in row &&
        row.labels?.map((label: any, idx: number) => (
          <Label
            key={idx}
            variant="soft"
            sx={{
              background: label.labelColor,
              color: getContrastYIQ(label.labelColor),
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              },
            }}
          >
            {label.labelName}
          </Label>
        ))}
    </Box>
  );
}
